function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSyseleveninline = function SvgSyseleveninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 1 250 97.96"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M55.738 46.512c0 6.77 6.048 7.812 10.406 9.417 2.509.913 4.39 1.997 4.39 4.341 0 2.776-1.65 4.207-5.584 4.207-3.935 0-7.951-1.344-7.951-1.344a7.901 8.104 0 0 0-1.27 4.425s3.637 1.91 9.434 1.91c7.233 0 10.914-3.3 10.914-9.326 0-5.554-3.806-7.635-7.616-9.07-3.68-1.344-7.358-2.08-7.358-4.824 0-2.82 1.944-4.21 6.048-4.21a21.73 22.29 0 0 1 6.302.965c.975-1.087 1.439-2.82 1.439-4.341 0 0-3.258-1.287-8.503-1.287-7.19 0-10.66 3.69-10.66 9.153",
    className: "syseleven_inline_svg__cls-1",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      strokeWidth: 0.317543
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.738 46.512c0 6.77 6.048 7.812 10.406 9.417 2.509.913 4.39 1.997 4.39 4.341 0 2.776-1.65 4.207-5.584 4.207-3.935 0-7.951-1.344-7.951-1.344a7.901 8.104 0 0 0-1.27 4.425s3.637 1.91 9.434 1.91c7.233 0 10.914-3.3 10.914-9.326 0-5.554-3.806-7.635-7.616-9.07-3.68-1.344-7.358-2.08-7.358-4.824 0-2.82 1.944-4.21 6.048-4.21a21.73 22.29 0 0 1 6.302.965c.975-1.087 1.439-2.82 1.439-4.341 0 0-3.258-1.287-8.503-1.287-7.19 0-10.66 3.69-10.66 9.153z",
    className: "syseleven_inline_svg__cls-2",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      stroke: "#6c7993",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.181 46.557a8.293 8.506 0 0 0-2.508-.347c-1.734 0-2.58.347-2.58.347l-3.415 11.63a53.012 54.377 0 0 0-1.354 5.467h-.17a38.32 39.307 0 0 0-1.48-5.468L83.7 46.557a8.832 9.06 0 0 0-2.75-.347 9.516 9.76 0 0 0-2.75.347s8.29 23.645 8.595 24.58c-1.273 3.792-2.038 4.233-4.11 4.233a14.676 15.054 0 0 1-1.948-.174 6.205 6.365 0 0 0-.38 2.17 5.644 5.789 0 0 0 .38 2.04 6.205 6.365 0 0 0 2.455.476c5.33 0 6.898-2.994 8.544-8.362l7.446-24.95Z",
    className: "syseleven_inline_svg__cls-1",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      strokeWidth: 0.317543
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.181 46.557a8.293 8.506 0 0 0-2.508-.347c-1.734 0-2.58.347-2.58.347l-3.415 11.63a53.012 54.377 0 0 0-1.354 5.467h-.17a38.32 39.307 0 0 0-1.48-5.468L83.7 46.557a8.832 9.06 0 0 0-2.75-.347 9.516 9.76 0 0 0-2.75.347s8.29 23.645 8.595 24.58c-1.273 3.792-2.038 4.233-4.11 4.233a14.676 15.054 0 0 1-1.948-.174 6.205 6.365 0 0 0-.38 2.17 5.644 5.789 0 0 0 .38 2.04 6.205 6.365 0 0 0 2.455.476c5.33 0 6.898-2.994 8.544-8.362l7.446-24.95Z",
    className: "syseleven_inline_svg__cls-2",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      stroke: "#6c7993",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.818 52.8c0 4.47 3.092 5.682 5.882 6.55 2.286.695 4.358 1.171 4.358 3.04 0 1.608-1.016 2.428-3.301 2.428a18.498 18.975 0 0 1-5.628-1.036c-.972.965-1.44 2.432-1.44 4.036 0 0 2.707 1.65 7.319 1.65 5.543 0 8.293-2.601 8.293-7.204 0-4.078-2.509-5.596-5.036-6.509-2.665-.965-5.374-1.257-5.374-3.123 0-1.563 1.185-2.431 3.64-2.431a14.968 15.353 0 0 1 4.315.695c.94-.91 1.354-2.474 1.354-3.86 0 0-1.693-1.26-6.217-1.26-5.544 0-8.168 2.82-8.168 7.03",
    className: "syseleven_inline_svg__cls-1",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      strokeWidth: 0.317543
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.818 52.8c0 4.47 3.092 5.682 5.882 6.55 2.286.695 4.358 1.171 4.358 3.04 0 1.608-1.016 2.428-3.301 2.428a18.498 18.975 0 0 1-5.628-1.036c-.972.965-1.44 2.432-1.44 4.036 0 0 2.707 1.65 7.319 1.65 5.543 0 8.293-2.601 8.293-7.204 0-4.078-2.509-5.596-5.036-6.509-2.665-.965-5.374-1.257-5.374-3.123 0-1.563 1.185-2.431 3.64-2.431a14.968 15.353 0 0 1 4.315.695c.94-.91 1.354-2.474 1.354-3.86 0 0-1.693-1.26-6.217-1.26-5.544 0-8.168 2.82-8.168 7.03z",
    className: "syseleven_inline_svg__cls-2",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      stroke: "#6c7993",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.352 37.793v31.241h18.74a5.882 6.033 0 0 0 .423-2.3 6.089 6.246 0 0 0-.424-2.17h-13.325v-9.07h10.786a5.822 5.972 0 0 0 .423-2.299 6.073 6.23 0 0 0-.423-2.168h-10.786v-8.766h12.902a6.164 6.323 0 0 0 .423-2.387 5.434 5.573 0 0 0-.423-2.08z",
    className: "syseleven_inline_svg__cls-3",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      strokeWidth: 0.317543
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.352 37.793v31.241h18.74a5.882 6.033 0 0 0 .423-2.3 6.089 6.246 0 0 0-.424-2.17h-13.325v-9.07h10.786a5.822 5.972 0 0 0 .423-2.299 6.073 6.23 0 0 0-.423-2.168h-10.786v-8.766h12.902a6.164 6.323 0 0 0 .423-2.387 5.434 5.573 0 0 0-.423-2.08z",
    className: "syseleven_inline_svg__cls-4",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      stroke: "#6c7993",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.639 36.838a8.534 8.754 0 0 0-2.665-.347c-1.863 0-2.665.347-2.665.347v31.84s.802.346 2.665.346a8.534 8.754 0 0 0 2.665-.347z",
    className: "syseleven_inline_svg__cls-3",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      strokeWidth: 0.317543
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.639 36.838a8.534 8.754 0 0 0-2.665-.347c-1.863 0-2.665.347-2.665.347v31.84s.802.346 2.665.346a8.534 8.754 0 0 0 2.665-.347z",
    className: "syseleven_inline_svg__cls-4",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      stroke: "#6c7993",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.963 54.758c0-6.204-3.427-8.982-8.673-8.982-5.838 0-9.644 3.515-9.644 11.716 0 7.853 3.045 11.976 9.942 11.976 4.703 0 7.193-1.778 7.193-1.778a5.644 5.789 0 0 0-1.609-3.86 11.56 11.858 0 0 1-4.822 1.043c-2.963 0-4.866-1.13-5.245-5.555h12.394a18.878 19.364 0 0 0 .464-4.557m-5.29-.643c0 .48-.04.965-.081 1.434h-7.446c.376-4.039 1.987-5.525 4.138-5.525 2.665 0 3.383 1.824 3.383 4.078",
    className: "syseleven_inline_svg__cls-3",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      strokeWidth: 0.317543
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.963 54.758c0-6.204-3.427-8.982-8.673-8.982-5.838 0-9.644 3.515-9.644 11.716 0 7.853 3.045 11.976 9.942 11.976 4.703 0 7.193-1.778 7.193-1.778a5.644 5.789 0 0 0-1.609-3.86 11.56 11.858 0 0 1-4.822 1.043c-2.963 0-4.866-1.13-5.245-5.555h12.394a18.878 19.364 0 0 0 .464-4.557zm-5.29-.643c0 .48-.04.965-.081 1.434h-7.446c.376-4.036 1.987-5.522 4.138-5.522 2.665 0 3.383 1.824 3.383 4.078z",
    className: "syseleven_inline_svg__cls-4",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      stroke: "#6c7993",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.72 46.557s-.888-.347-2.75-.347a9.516 9.76 0 0 0-2.75.347l7.19 22.13a14.062 14.424 0 0 0 3.298.347 15.501 15.9 0 0 0 3.301-.347l7.02-22.13s-.802-.347-2.451-.347a7.371 7.56 0 0 0-2.411.347L194.232 59.1c-.806 2.573-1.31 4.904-1.31 4.904h-.17a38.593 39.586 0 0 0-1.148-4.862l-3.89-12.585z",
    className: "syseleven_inline_svg__cls-3",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      strokeWidth: 0.317543
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.72 46.557s-.888-.347-2.75-.347a9.516 9.76 0 0 0-2.75.347l7.19 22.13a14.062 14.424 0 0 0 3.298.347 15.501 15.9 0 0 0 3.301-.347l7.02-22.13s-.802-.347-2.451-.347a7.371 7.56 0 0 0-2.411.347L194.232 59.1c-.806 2.573-1.31 4.904-1.31 4.904h-.17a38.593 39.586 0 0 0-1.148-4.862l-3.89-12.585z",
    className: "syseleven_inline_svg__cls-4",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      stroke: "#6c7993",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.691 54.758c0-6.204-3.423-8.982-8.672-8.982-5.835 0-9.644 3.515-9.644 11.716 0 7.853 3.047 11.976 9.942 11.976 4.703 0 7.192-1.778 7.192-1.778a5.644 5.789 0 0 0-1.608-3.86 11.544 11.841 0 0 1-4.822 1.043c-2.963 0-4.866-1.13-5.246-5.555h12.394a18.878 19.364 0 0 0 .464-4.557m-5.286-.643c0 .48-.04.965-.084 1.434h-7.447c.38-4.036 1.988-5.512 4.145-5.512 2.665 0 3.386 1.824 3.386 4.078",
    className: "syseleven_inline_svg__cls-3",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      strokeWidth: 0.317543
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.691 54.758c0-6.204-3.423-8.982-8.672-8.982-5.835 0-9.644 3.515-9.644 11.716 0 7.853 3.047 11.976 9.942 11.976 4.703 0 7.192-1.778 7.192-1.778a5.644 5.789 0 0 0-1.608-3.86 11.544 11.841 0 0 1-4.822 1.043c-2.963 0-4.866-1.13-5.246-5.555h12.394a18.878 19.364 0 0 0 .464-4.557zm-5.286-.643c0 .48-.04.965-.084 1.434h-7.447c.38-4.036 1.988-5.512 4.145-5.512 2.665 0 3.386 1.823 3.386 4.078z",
    className: "syseleven_inline_svg__cls-4",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      stroke: "#6c7993",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.128 52.372c0-3.904-2.286-6.596-6.64-6.596-2.327 0-4.315.694-5.798 2.084v-1.303a8.525 8.744 0 0 0-2.662-.347c-1.881 0-2.668.347-2.668.347v22.13s.803.347 2.668.347a8.525 8.744 0 0 0 2.662-.347V51.809a5.396 5.535 0 0 1 3.725-1.608c2.41 0 3.383 1.26 3.383 3.126v15.36s.802.347 2.665.347a8.534 8.754 0 0 0 2.665-.347z",
    className: "syseleven_inline_svg__cls-3",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      strokeWidth: 0.317543
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.128 52.372c0-3.904-2.286-6.596-6.64-6.596-2.327 0-4.315.694-5.798 2.084v-1.303a8.525 8.744 0 0 0-2.662-.347c-1.881 0-2.668.347-2.668.347v22.13s.803.347 2.668.347a8.525 8.744 0 0 0 2.662-.347V51.809a5.396 5.535 0 0 1 3.725-1.608c2.41 0 3.383 1.26 3.383 3.126v15.36s.802.347 2.665.347a8.534 8.754 0 0 0 2.665-.347z",
    className: "syseleven_inline_svg__cls-4",
    style: {
      fill: "#6c7993",
      fillOpacity: 1,
      stroke: "#6c7993",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.29 133.31 0 159.6l26.29 26.28 26.27-26.28zM93.32 66.28 67.04 92.56l26.28 26.28 26.28-26.28zM60.56 33.52 34.28 59.8l26.28 26.28L86.84 59.8zM59.8 99.8l-26.28 26.28 26.28 26.28 26.28-26.28zM27.04 67.04.76 93.32l26.28 26.29 26.29-26.29zM126.84 32.76l-26.28 26.28 26.28 26.28 26.28-26.28zM120.36 26.28 94.08 0 67.8 26.28l26.28 26.28zM59.04 166.08l-26.28 26.28 26.28 26.28 26.28-26.28zM126.08 99.04 99.8 125.32l26.28 26.28 26.28-26.28zM92.56 132.55l-26.28 26.29 26.28 26.28 26.28-26.28zM159.6 65.52 133.32 91.8l26.28 26.28 26.28-26.28z",
    className: "syseleven_inline_svg__cls-1",
    style: {
      fill: "#6c7993",
      fillOpacity: 1
    },
    transform: "matrix(.31353 0 0 .3216 -1.212 .381)"
  }));
};
export default SvgSyseleveninline;